export default class TrackingService {

    constructor() {
        //fix npe if o tracking is not available
        this.tracker = window.o_tracking || {};
        if (!this.tracker.bct) {
            this.tracker.bct = {
                sendMergeToTrackingServer: () => {
                },
                sendEventToTrackingServer: () => {
                },
                submitMove: () => {
                },
            }
        }
    }

    sendClickTrackingEvent(promoType, destination, featureOrder, featureIndex, filledSlots, position, source) {
        const clickTrackingInfo = this._buildClickTrackingPayload(promoType, destination, featureOrder, featureIndex, filledSlots, position, source, "click");
        this.tracker.bct.submitMove(clickTrackingInfo);
    }

    sendViewTrackingEvent(promoType, destinationsArray, featureOrder, featureIndex, filledSlots, sourcesArray) {
        const viewTrackingInfo = this._getViewTrackingInfo(filledSlots, destinationsArray, featureOrder, featureIndex, sourcesArray, promoType);

        this.tracker.bct.sendMergeToTrackingServer(viewTrackingInfo);
    }

    sendViewTrackingEventHidden(promoType, destination, featureOrder, featureIndex, filledSlots, source, slideIndex, movementType) {
        const viewTrackingInfo = {};
        viewTrackingInfo["promo_" + promoType] = this._getEventAsString(destination, featureOrder, featureIndex, filledSlots, slideIndex, source, 'view');
        if (movementType) {
            viewTrackingInfo["promo_FeatureInteraction"] = this._getMovementTrackingInfoAsString(promoType, featureOrder, featureIndex, filledSlots, movementType);
        }
        this.tracker.bct.sendEventToTrackingServer(viewTrackingInfo);
    }

    sendMovementTrackingEventHidden(promoType, featureOrder, featureIndex, filledSlots, movementType) {
        const movementTrackingInfo = {"promo_FeatureInteraction": this._getMovementTrackingInfoAsString(promoType, featureOrder, featureIndex, filledSlots, movementType)};
        this.tracker.bct.sendEventToTrackingServer(movementTrackingInfo);
    }

    _getViewTrackingInfo(filledSlots, destinationsArray, featureOrder, featureIndex, sourcesArray, promoType) {
        let promos = [];
        const action = "view";
        for (let pos = 0; pos < destinationsArray.length; ++pos) {
            promos.push(this._getEventAsString(destinationsArray[pos], featureOrder, featureIndex, filledSlots, (pos + 1), sourcesArray[pos], action));
        }

        const viewTrackingInfo = {};
        viewTrackingInfo["promo_" + promoType] = promos.join("|");
        return viewTrackingInfo;
    }

    _buildClickTrackingPayload(promoType, destination, featureOrder, featureIndex, filledSlots, position, source, action) {
        const clickTrackingInfo = {};
        clickTrackingInfo["promo_" + promoType] = this._getEventAsString(destination, featureOrder, featureIndex, filledSlots, position, source, action);
        clickTrackingInfo["wk.promo_Attribution"] = "promo_" + promoType + "∞" + this._getEventAsString(destination, featureOrder, featureIndex, filledSlots, position, source, action);
        return clickTrackingInfo;
    }

    _getEventAsString(destination, featureOrder, featureIndex, filledSlots, position, source, action) {
        const featureNumber = featureIndex + 1;
        return destination + "∞" + featureOrder + "$" + featureNumber + "∞" + filledSlots + "∞" + position + "∞" + source + "∞" + action;
    }

    _getMovementTrackingInfoAsString(promoType, featureOrder, featureIndex, filledSlots, movementType) {
        const featureNumber = featureIndex + 1;
        return promoType + "∞" + featureOrder + "$" + featureNumber + "∞" + filledSlots + "∞" + movementType;
    }

}
